import {
  SlAvatar
} from "./chunk.LC7H7NPQ.js";

// src/components/avatar/avatar.ts
var avatar_default = SlAvatar;
SlAvatar.define("sl-avatar");

export {
  avatar_default
};
